export default "/fonts/Acrom-ExtraBold.woff?86a86c0c5ba7f324e42fe779d4f56f74";